interface HeaderBgProps {
  children: React.ReactNode;
}

export function HeaderBg({ children }: HeaderBgProps) {
  return (
    <div className="relative min-h-[232px] w-full">
      <img
        src="/images/qa-bg.jpg"
        alt="background"
        // width={1920}
        // height={232}
        className="absolute left-0 top-0 h-full w-full object-cover"
      />
      <div className="inset-0">
        <div className="mx-auto max-w-[1280px] px-4">
          <div className="relative h-full">{children}</div>
        </div>
      </div>
    </div>
  );
}
